import { Box, Dialog, Typography } from "@mui/material";
import styles from "../../devoteeService/priestSchedule/priestSchedule.module.scss";
import CloseIcon from "@mui/icons-material/Close";

const InvoiceDialog = (props: any) => {
  const { handleClose, open, poojaBookingDetails, isHall } = props;

  const {
    firstname,
    middleName,
    lastname,
    id,
    poojaName,
    priestName,
    suggestedDonation,
    miles,
    address,
    city,
    state,
    zipcode,
    endTime,
    startTime,
    charge,
    startDate,
  } = poojaBookingDetails || {};

  const templeDetails = () => {
    return (
      <Box
        className={styles.temple_details}
        sx={{
          display: "flex",
          flexDirection: { xs: "column", sm: "row" },
          justifyContent: "space-between",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Box
            component="img"
            src="/images/TempleOldLogo.png"
            className={styles.temple_image}
            sx={{}}
          />
          <Typography className={styles.temple_name_data}>
            Shiva -Vishnu Temple
          </Typography>
        </Box>
        <Box
          className={styles.temple_address}
          sx={{ textAlign: { xs: "left", sm: "right" } }}
        >
          <Typography className={styles.temple_address_data}>
            <span style={{ fontWeight: "bold", letterSpacing: "1px" }}>
              Hindu Community and Cultural Center
            </span>
            <br />A Registered Non-Profit Organization
            <br />
            Tax ID: 94-2427126, Inc: D08215891232,
            <br /> Arrowhead Ave, Livermore, CA 94551 <br />
            Tel: (925) 449-6255, Fax: (925) 455-0404.
          </Typography>
        </Box>
      </Box>
    );
  };

  const poojaDetails = () => {
    return (
      <Box
        className={styles.pooja_details_container}
        mb="20px"
        mt={{ xs: "24px", sm: "0px" }}
      >
        <Box className={styles.pooja_details_left_container}>
          <Typography className={styles.pooja_details_header}>
            Schedule ID
          </Typography>
          <Typography className={styles.pooja_details_header}>
            Devotee Name
          </Typography>
          <Typography
            className={styles.pooja_details_header}
            sx={{ height: `${address ? "67.2px" : "44.8px"}` }}
          >
            Devotee Address
          </Typography>
          <Typography className={styles.pooja_details_header}>
            {isHall ? "Purpose" : "Pooja Name"}
          </Typography>
          <Typography className={styles.pooja_details_header}>
            {isHall ? "Booked Date" : "Pooja Date"}
          </Typography>
          <Typography className={styles.pooja_details_header}>
            {!isHall ? "Priest" : "Hall"} Name
          </Typography>
          <Typography className={styles.pooja_details_header}>
            Suggested Donation
          </Typography>
          <Typography className={styles.pooja_details_header}>
            Total Miles
          </Typography>
          <Typography className={styles.pooja_details_header}>
            Charge
          </Typography>
        </Box>
        <Box className={styles.pooja_details_right_container}>
          <Typography className={styles.pooja_details_text}>{id}</Typography>
          <Typography className={styles.pooja_details_text}>
            {firstname} {middleName} {lastname}
          </Typography>
          <Typography
            className={styles.pooja_details_text}
            sx={{ height: `${address ? "67.2px" : "44.8px"}` }}
          >
            {address}
            {address ? "," : ""}
            {address && <br />}
            {city}
            {city ? "," : ""}
            {city && <br />}
            {state} - {zipcode}
          </Typography>
          <Typography className={styles.pooja_details_text}>
            {poojaName}
          </Typography>
          <Typography className={styles.pooja_details_text}>
            {startDate} ({startTime} - {endTime})
          </Typography>
          <Typography className={styles.pooja_details_text}>
            {priestName}
          </Typography>
          <Typography className={styles.pooja_details_text}>
            ${suggestedDonation}
          </Typography>
          <Typography className={styles.pooja_details_text}>
            {miles} Miles
          </Typography>
          <Typography className={styles.pooja_details_text}>
            ${charge ? charge : 0}
          </Typography>
        </Box>
      </Box>
    );
  };

  return (
    <Dialog
      onClose={handleClose}
      open={open}
      PaperProps={{
        sx: {
          width: { xs: "100%", md: "710px" },
          maxWidth: { xs: "100%", sm: "710px" },
          margin: { xs: "10px", sm: "20px" },
          backgroundColor: "#FFF9E4",
        },
      }}
    >
      <Box
        className={styles.invoice_dialog_main_container}
        sx={{
          width: "100%",
        }}
      >
        <Box className={styles.dialog_title_container}>
          <Typography className={styles.title}>
            {isHall ? "Hall Booking Details" : "Pooja Details for Priest"}
          </Typography>
          <CloseIcon
            sx={{ color: "white", cursor: "pointer" }}
            onClick={handleClose}
          />
        </Box>
        <Box className={styles.dialog_inner_container}>
          {templeDetails()}
          {poojaDetails()}
        </Box>
      </Box>
    </Dialog>
  );
};

export default InvoiceDialog;
